import store from '@/store'
import { SSharedAuth } from '@/services/shared'
import { setClusters } from '@/forage/shared/clusters'

/* eslint-disable-next-line */
export default async (_to, _from, next) => {
  const hasUser = store.getters['auth/user']
  const token = store.getters['auth/token']

  if (!hasUser && token) {
    await SSharedAuth.getCurrentUser().then(
      ({ data }) => {
        setClusters(data?.clusters || [])
        store.dispatch('auth/fetchUserSuccess', {
          id: data.id,
          email: data.email,
          team: data.team?.id,
          team_code: data.team?.team_code,
          team_name: data.team?.team_name,
          area: data.area?.id,
          area_code: data.area?.area_code,
          area_name: data.area?.area_name,
          role_id: data.role?.id,
          role: data.role?.role_code,
          role_name: data.role?.role_name,
          username: data.username,
          name: data.name,
          first_name: data.first_name,
          last_name: data.last_name,
          mobile_number: data.mobile_number,
          notification_email: data.notification_email,
          photo_url: data.photo_url,
          can_verify: data.can_verify
        })
      }
    ).catch(() => {
      store.dispatch('auth/fetchUserFailure')
    })
  }

  next()
}
